"use client";

import { c as _c } from "react/compiler-runtime";
import { useSession } from "@/lib/auth-client";
import { useAuth } from "@/providers/auth";
import type { MembershipPlanId } from "@/types/membership";

/**
 * Pool catalog fetch key / plan — derived from session + AuthProvider membership merge
 * (including debug plan override). Kept out of AuthContext so pools hooks don't pull
 * unrelated auth surface.
 */
export function usePoolsAuthScope() {
  const $ = _c(4);
  const {
    data: session,
    isPending
  } = useSession();
  const {
    user
  } = useAuth();
  const poolsFetchScope = session?.user?.id ?? "anonymous";
  const poolsFetchPlanId = user?.membership.planId ?? "free";
  const isPoolsFetchReady = !isPending;
  let t0;
  if ($[0] !== isPoolsFetchReady || $[1] !== poolsFetchPlanId || $[2] !== poolsFetchScope) {
    t0 = {
      poolsFetchScope,
      poolsFetchPlanId,
      isPoolsFetchReady
    };
    $[0] = isPoolsFetchReady;
    $[1] = poolsFetchPlanId;
    $[2] = poolsFetchScope;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}